import { ContactFormContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../../section/Primitive"

/* Protopia Ecosystem component */
export interface ICFDescriptionProps extends IPrimitiveProps {
   
}
const CFDescription = (props: ICFDescriptionProps): JSX.Element => {
    const primitive: ContactFormContent = ( props.primitive || {} ) as ContactFormContent
        return !! primitive.description 
            ?
            <div className='pe-cf-description-container'>
                { primitive.description }
            </div>
            :
            <></>
}
export default CFDescription